<template>
  <div class="payment-plans gantt-scroll" :style="{ width: width, height: '100vh' }">
    <div class="content">
      <div class="closer" :style="{ width: '24px', height: '24px' }" @click="close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.9697 16.0303C15.2626 16.3232 15.7374 16.3232 16.0303 16.0303C16.3232 15.7374 16.3232 15.2626 16.0303 14.9697L13.0607 12L16.0303 9.03034C16.3232 8.73744 16.3232 8.26257 16.0303 7.96968C15.7374 7.67678 15.2626 7.67678 14.9697 7.96968L12 10.9393L9.03033 7.96967C8.73744 7.67678 8.26256 7.67678 7.96967 7.96967C7.67678 8.26256 7.67678 8.73744 7.96967 9.03033L10.9393 12L7.96967 14.9697C7.67678 15.2626 7.67678 15.7374 7.96967 16.0303C8.26256 16.3232 8.73744 16.3232 9.03033 16.0303L12 13.0607L14.9697 16.0303Z"
              fill="#333333" />
          </svg>

        </div>
      <div ref="head" class="head">

        <div class="main-title">
          {{ locales('plans_popup_title') }}
        </div>

        <div :class="['period-tabs', isAnnual ? 'annual' : 'month']">
    
          <div class="tab annually" @click="toggleAnnual(true)">
            <div :class="['save-item', isAnnual ? 'dnone' : '']">
              <discount-svg />
            </div>
            <div>{{ locales('plans_annually_locale') }}</div>
          </div>
          <div class="tab monthly" @click="toggleAnnual(false)">
            {{ locales('plans_monthly_locale') }}
          </div>
        </div>

      </div>
      <div class="body">
        <div
          ref="plansSection"
          class="plans"
        >
          <plan-item
            v-for="(plan, index) in plans"
            :key="index"
            :plan="plan"
            :is-annual="isAnnual"
            :is-popup="false"
            :number-of-plan="numberOfPlanItems"
          />
        </div>
        <div ref="studentsSection" class="students-container">
          <div class="students">
            <div class="students__inner">
              <p class="students__title">
                {{ locales('plans_students_title') }}
              </p>
              <p class="students__desc" v-html="locales('plans_students_description')" />
              <div class="students__btn">
                <button class="btn btn--transparent" @click="studentsClick">
                {{ locales('learn_more') }}
              </button>
              </div>
              
            </div>
          </div>
        </div>
        <div ref="features" class='features border-wrapper' id="features">
          <div ref="table" class="table">
            <div ref="tableHead" class="table-head">
              <div ref="tableHeadTitle" class="table-head-title">
                <div class="features-title title-h2">
                {{ locales('pricing_plans_features_table_head') }}
              </div>
            </div>
              <div class="head-plans-wrapper">
                <div v-for="(plan, index) in plans" :key="index" :class="['table-plan-cell head-cell', plan.name]">
                  <div v-if="plan.name !== 'enterprise'" class="inner-info">
                    <div class="plan-name">
                      {{ locales(`${plan.name}_plan_locale`) }}
                    </div>
                    <div class="price-desc">
                      {{ `$ ${currentPrice(plan)}` }}
                    </div>
                  </div>
                  <div v-else class="inner-info">
                    <div class="plan-name">
                      {{ locales(`${plan.name}_plan_locale`) }}
                    </div>
                    <div class="price-desc">
                      {{ locales('lets_talk_locale') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div ref="tableBody" :class="`table-body ${this.isCollapsed ? 'collapsed' : ''}`">
              <table-group v-for="(group, index) in featuresTable" ref="tableGroup" :key="index" :plans="plans"
                :group="group" />
            </div>
          </div>
          <div :class="`table-collapse ${this.isCollapsed ? 'collapsed' : ''}`" @click="collapseTable()" ref="tableCollapse">
            <button>{{`${this.isCollapsed ? locales('pricing_table_collapse_hide') : locales('pricing_table_collapse_show')}`}} 
              <svgImage :name="'pricing-table-collapse-icon'" />
            </button>
          </div>
        </div>
        <div ref="faq" class="faq">
          <div class="faq-title">
            {{ locales('faq_plans_locales') }}
          </div>
          <div class="faq-list">
            <div v-for="(item, index) in faqConfig" :key="index" class="faq-item" :data-key="item.key"
              @click="showAnswer">
              <div class="question">
                {{ item.question }}
              </div>
              <div class="check-icon">
                <webix-ui :config="icons.checkIcon" />
              </div>
              <div class="answer" v-html="item.answer" />
            </div>
          </div>
        </div>
        <div ref="footer" class="contact-footer">
          <div class="footer-title">
            {{ locales('plans_popup_footer_title') }}
          </div>
          <div class="contact-us" @click="chatClick" v-html="locales('footer_contact_link_locale')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import svgIconForVue from '../common/svgIconForVue';
import plansModel from '../../models/plans';
import planItem from './components/planItem.vue';
import discountSvg from './components/discountSvg.vue';
import tableGroup from './components/tableGroup.vue';

import checkIcon from '../../svg/pricing/faq_arrow_down.svg';
import bubleSmallIcon from '../../svg/pricing/bubble_ic_small.svg';
import helpers from './helpers';
import svgImage from '../common/VueComponents/VueIcon/vgpSvgImage.vue';


export default {
  components: {
    planItem,
    tableGroup,
    discountSvg,
    svgImage
  },
  data() {
    return {
      locales: __,
      isAnnual: true,
      plans: [],
      realUsers: '',
      featuresTable: [],
      numberOfPlan: [1, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50,
        // 55, 60, 65, 70, 75, 80, 85, 90, 95, 100
      ],
      numberOfPlanItems: [],
      faqConfig: [
        {
          question: __('question_locale_1'),
          answer: __('answer_locale_1'),
          key: 'free',
        },
        {
          question: __('question_locale_2'),
          answer: __('answer_locale_2'),
          key: 'payment options',
        },
        {
          question: __('question_locale_3'),
          answer: __('answer_locale_3'),
          key: 'discounts',
        },
        {
          question: __('question_locale_4'),
          answer: __('answer_locale_4'),
          key: 'data hosted',
        },
        {
          question: __('question_locale_5'),
          answer: __('answer_locale_5'),
          key: 'gdpr',
        },
        // {
        //   question: __('question_locale_6'),
        //   answer: __('answer_locale_6'),
        // },
        // {
        //   question: __('question_locale_7'),
        //   answer: __('answer_locale_7'),
        // },
      ],
      isActive: false,
      isCollapsed: false,
      icons: {
        checkIcon: svgIconForVue(checkIcon, 24, 24),
        bubleIcon: svgIconForVue(bubleSmallIcon, 21, 21),
      },
    };
  },
  computed: {
    isShow() {
      return this.$store.getters['plansPopup/isShowPlans'];
    },
    width() {
      const sidebarWidth = this.$store.getters.leftSidebarWidth;
      const width = `calc(100% - ${sidebarWidth + 1}px)`;

      return width;
    },
    nextCount() {
      return this.$store.getters['paymentPlans/nextCount'];
    },
  },
  watch: {
    $route(to, from) {
      this.$store.commit('paymentPlans/close');
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.mountTableLayout();
  },
  methods: {
    init() {
      this.plans = user.paymentPlans.filter(value => {
        if (value.id !== 17) {
          return value;
        }
      });
      this.realUsers = this.$store.getters['resourcesModel/getAllRealResources'].length;
      let nextCount;

      if (plansModel.isTrial() || plansModel.isRefunded() || plansModel.isTerminated()) {
        if (this.realUsers === 2) {
          nextCount = this.numberOfPlan[1];
        } else {
          const next = this.numberOfPlan.find(num => num >= this.realUsers);

          nextCount = next || this.realUsers;
        }
      } else {
        nextCount = this.realUsers > 1 ? this.numberOfPlan.find(num => num >= this.realUsers) : this.numberOfPlan[1];
      }

      this.featuresTable = helpers.getTableFeatures();
      this.$store.commit('paymentPlans/setNextCount', nextCount);
      this.setSelectItems(this.numberOfPlan);
      userExtAnalytics.log('pricing_upgrade_account_clicked');
    },
    mountTableLayout() {
      const mainNode = this.$el;
      const table = this.$refs.table;
      const tableHead = this.$refs.tableHead;
      const tableCollapse = this.$refs.tableCollapse;
 
      mainNode.addEventListener('scroll', () => {
        if (table.getBoundingClientRect().top < 0 && table.getBoundingClientRect().bottom - tableCollapse.clientHeight > 0) {
          tableHead.classList.add('fixed');
          tableHead.style.top = null;
        }
        else if (table.getBoundingClientRect().top > 0) {
          tableHead.classList.remove('fixed');
        }
        else if (table.getBoundingClientRect().bottom - tableCollapse.clientHeight < 0) {
          tableHead.style.top = table.getBoundingClientRect().bottom - tableCollapse.clientHeight + "px";
        }
      });
    },
    setSelectItems(numbers) {
      const preparedCountItems = numbers.map(num => {
        const countConfig = {};

        countConfig.value = num;
        if (num < this.realUsers) {
          countConfig.disabled = true;
        } else {
          countConfig.disabled = false;
        }

        return countConfig;
      });

      this.numberOfPlanItems = preparedCountItems;
    },
    close() {
      this.$store.commit('paymentPlans/close');
    },
    removeHeight() {
      this.$el.querySelectorAll('.faq-item').forEach(item => {
        item.classList.remove('active');
        item.querySelector('.answer').style.position = 'absolute';
        item.querySelector('.answer').style.zIndex  = '-1';
        item.querySelector('.answer').style.opacity = 0;
        item.querySelector('.answer').style.maxHeight = 0;
        
        item.querySelector('.check-icon').classList.remove('active');
      });
    },
    showAnswer(e) {
      const faqItem = e.target.closest('.faq-item');
      const answerNode = faqItem.querySelector('.answer');
      const checkIcon = faqItem.querySelector('.check-icon');
      const contentHeight = answerNode.scrollHeight;
      const dataKey = e.target.dataset.key;

      userExtAnalytics.log('pricing_faq_opened', dataKey);

      if (faqItem.classList.contains('active')) {
        checkIcon.classList.remove('active');
        this.removeHeight();

        return;
      }
      this.removeHeight();
      faqItem.classList.add('active');
      checkIcon.classList.add('active');
      answerNode.style.position = 'relative';
      answerNode.style.zIndex  = '1';
      answerNode.style.opacity  = '1';
      // answerNode.style.maxHeight = `${contentHeight + 20}px`;
      answerNode.style.maxHeight = `${contentHeight + 40}px`;
    },
    toggleAnnual(flag) {
      this.isAnnual = flag;
      const selectItems = this.numberOfPlanItems;
      const nextCount = this.$store.getters['paymentPlans/nextCount'];
      const startCountMonth = selectItems.find(item => item.value === 5);
      const firstItem = this.numberOfPlanItems.find(item => item.value === 1);
      firstItem.disabled = false;

      this.$store.commit('paymentPlans/setNextCount', !flag ? startCountMonth.value : firstItem.value);
   
      if (!flag && this.realUsers >= 1) {
        firstItem.disabled = true;
        selectItems.splice(0, 1, firstItem);
      } else if (flag && this.realUsers > 1) {
        firstItem.disabled = true;
        selectItems.splice(0, 1, firstItem);
      }
      userExtAnalytics.log('pricing_period_changed', { type: this.isAnnual ? 'annually' : 'monthly' });
      this.numberOfPlanItems = selectItems;
    },
    chatClick(e) {
      const target = e.target.closest('.contact-us');
      const contactLink = target.querySelectorAll('span');

      contactLink && this.$store.dispatch('footer/chatClickHandler');
    },
    studentsClick() {
      this.$store.commit('paymentPlans/showStudentsPage', true);
    },
    collapseTable() {
      this.isCollapsed = !this.isCollapsed;
    },
    currentPrice(plan) {
      return (this.isAnnual) ? plan.annual_price_usd : plan.month_price_usd;
    }
  },
};
</script>

<style scoped src="./less/paymentPlans.less"></style>
<style lang="less">
.closer {
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 2px;

  &:hover {
    .webix_template {
      background-color: #eee;
      cursor: pointer;
    }
  }
}

.check-icon {
  .webix_template {
    cursor: pointer;
  }
}
.contact-us {
  span {
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-underline-position: from-font;
  }
}
</style>
